import { EventEmitter, Injectable, Output } from '@angular/core';
import { TranslatorService } from '../../../shared/services/utils/translator.service';

@Injectable()
export class DropDownService {

  @Output() getUserCompleted: EventEmitter<void> = new EventEmitter();
  @Output() getCompanyCompleted: EventEmitter<void> = new EventEmitter();
  constructor(private readonly translationService: TranslatorService) { }

  getConfiguration(singleSelection: boolean, itemsShowLimit = 3, isRoleUser?: string, isPlanDay?: boolean): any {
    return {
      singleSelection,
      idField: 'id',
      textField: 'name',
      selectAllText: this.translationService.trans('pages.leads.select_all'),
      unSelectAllText: this.translationService.trans('pages.leads.unselect_all'),
      itemsShowLimit,
      allowSearchFilter: true,
      searchPlaceholderText: this.translationService.trans('pages.leads.search'),
      closeDropDownOnSelection: true,
      isRoleUser,
      isPlanDay
    };
  }

}
